import {
  ForkKnifeIcon,
  CoffeeIcon,
  MartiniIcon,
  BeerSteinIcon,
  CookieIcon,
  ShoppingCartIcon,
  StorefrontIcon,
  BasketIcon,
  BedIcon,
  BarbellIcon,
  FilmSlateIcon,
  BankIcon,
  PillIcon,
  ForkKnifeIcon as DefaultIcon,
  type Icon,
  type IconWeight,
} from "@phosphor-icons/react";

// Business-type slug -> glyph. Slugs match the canonical business_type values.
const GLYPHS: Record<string, Icon> = {
  restaurant: ForkKnifeIcon,
  cafe: CoffeeIcon,
  bar: MartiniIcon,
  pub: BeerSteinIcon,
  bakery: CookieIcon,
  supermarket: ShoppingCartIcon,
  food: ShoppingCartIcon,
  store: StorefrontIcon,
  shop: StorefrontIcon,
  grocery: BasketIcon,
  hotel: BedIcon,
  lodging: BedIcon,
  gym: BarbellIcon,
  cinema: FilmSlateIcon,
  bank: BankIcon,
  pharmacy: PillIcon,
};

export function glyphForBusinessType(businessType?: string | null): Icon {
  const key = (businessType || "").trim().toLowerCase();
  return GLYPHS[key] ?? DefaultIcon;
}

interface BusinessTypeGlyphProps {
  businessType?: string | null;
  size: number;
  color: string;
  weight?: IconWeight;
}

/** Render the business-type glyph (used on map pins). */
export function BusinessTypeGlyph({
  businessType,
  size,
  color,
  weight = "fill",
}: BusinessTypeGlyphProps) {
  const Glyph = glyphForBusinessType(businessType);
  return <Glyph size={size} color={color} weight={weight} />;
}
